import { call, put, takeEvery, fork } from "redux-saga/effects";
import * as actions from "../actions/favoritos";
import favoritos from "../services/favoritos";

function* getProductoFavoritos({ clienteId, contactoId }) {
  yield put(actions.startLoading());
  try {
    const response = yield call(
      favoritos.getProductoFavoritos,
      clienteId,
      contactoId,
    );
    if (response) {
      yield put(actions.getFavoritosSucceeded(response));
    }
  } catch (err) {
    yield put(actions.getFavoritosError(err));
    console.log(err);
  }
}

function* agregarProductoFavorito({ request }) {
  try {
    const res = yield call(favoritos.agregarProductoFavorito, request);
    yield put(actions.postAgregarFavoritosSucceeded());
  } catch (error) {
    yield put(actions.postAgregarFavoritosError(error));
  }
}

function* eliminarProductoFavorito({ request }) {
  try {
    const res = yield call(favoritos.eliminarProductoFavorito, request);
    yield put(actions.postEliminarFavoritosSucceeded());
  } catch (error) {
    yield put(actions.postEliminarFavoritosError(error));
  }
}

function* getEsFavorito({ clienteId, contactoId, productoId }) {
  yield put(actions.startLoading());
  try {
    const res = yield call(
      favoritos.esFavorito,
      clienteId,
      contactoId,
      productoId,
    );
    yield put(actions.getEsFavoritoSucceeded(res.esFavorito));
  } catch (err) {
    yield put(actions.getFavoritosError(err));
  }
}

function* watchGetProductoFavoritos() {
  yield takeEvery(actions.Types.FAVORITOS_GET_REQUEST, getProductoFavoritos);
}
function* watchAgregarFavoritos() {
  yield takeEvery(
    actions.Types.FAVORITOS_AGREGAR_REQUEST,
    agregarProductoFavorito,
  );
}
function* watchEliminarFavoritos() {
  yield takeEvery(
    actions.Types.FAVORITOS_ELIMINAR_REQUEST,
    eliminarProductoFavorito,
  );
}

function* watchGetEsFavorito() {
  yield takeEvery(actions.Types.FAVORITOS_ES_FAVORITO_REQUEST, getEsFavorito);
}

const favoritosSagas = [
  fork(watchGetProductoFavoritos),
  fork(watchAgregarFavoritos),
  fork(watchEliminarFavoritos),
  fork(watchGetEsFavorito),
];

export default favoritosSagas;
